<template>
  <el-container style="width: 100%; height: 100%;">
    <lx-navigator nav-title="实训设置" nav-active="1-1" :menuItems="menuItems"></lx-navigator>

    <el-main style="padding: 0 10px; height: 100%; ">
      <lx-step-bar step-first="汽车维修培训" :step-second="stepSecond">
      </lx-step-bar>
      <el-row class="lx-right-sub-title">
        <el-col :span="20"><i></i>当前总分：{{totalScore}}分</el-col>
      </el-row>
      <el-row style="height: calc(100% - 160px); overflow-y: auto; background: #fff; padding: 10px;">
        <el-col :span="24">
          <el-table :data="trainingData" size="medium" border class="lx-table" row-class-name="lx-table-row" header-cell-class-name="lx-table-header-cell" cell-class-name="lx-table-cell">
            <el-table-column prop="name" align="center" label="步骤名称"></el-table-column>
            <el-table-column prop="resource.name" align="center" label="资源名称"></el-table-column>
            <el-table-column align="center" label="资源类型">模型</el-table-column>
            <el-table-column align="center" label="试题" min-width="300">
              <template slot-scope="scope">
                <el-tag v-for="(ques, index) in scope.row.questions"
                        type="info"
                        style="background-color: #F7F7F7; border-color: #DDDDDD; color: #63666f; margin-right: 10px;"
                        :key="ques.value"
                        closable
                        :disable-transitions="false"
                        @close="handleDeleteQuestion(ques, scope.row)">
                  {{ '第' + (index + 1) + '题' + '（' + ques.score + '分）' }}
                  <i class="el-icon-edit"
                      @click="handleEditQuestion(ques, scope.row)"></i>
                </el-tag>
                <el-tag style="border-style: dashed; background-color: transparent; color: #63666f; border-color: #dddddd; cursor: pointer;"
                        @click.native="handleAddQuestion(scope.row)">+添加</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="processOrder" align="center" label="动画序列号"></el-table-column>
            <el-table-column prop="processOrder" align="center" label="显示顺序"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <lx-question-editor-box :visible.sync="quesEditorVisible" :quesIdentity="quesIdentify" :processIdentify="processIdentify" :apiIndentity="apiIdentity" @edit-result="handleEditResult"></lx-question-editor-box>
      <!-- <el-row class="lx-pagination-row">
        <el-col :span="24">
          <el-pagination :total="trainingData.total"
                          :page-size="trainingData.size"
                          :current-page.sync="trainingData.page"
                          background
                          layout="total, prev, pager, next"
                          @current-change="handleCurrentChange"></el-pagination>
        </el-col>
      </el-row> -->
    </el-main>
  </el-container>
</template>

<script>
import _ from 'lodash'
import Navigator from '@/components/common/Navigator'
import StepBar from '@/components/common/StepBar'
import QuestionEditor from '@/components/training/QuestionEditor'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
export default {
  props: ['display-type'],

  data () {
    return {
      menuItems: [
        { index: '1-1', name: '实训设置', route: { name: 'TrainingSetting' } }
      ],
      trainingData: [],
      stepSecond: '',
      apiIdentity: '',
      quesIdentify: {},
      processIdentify: {},
      quesEditorVisible: false
    }
  },

  components: { 'lx-navigator': Navigator, 'lx-step-bar': StepBar, 'lx-question-editor-box': QuestionEditor },

  watch: {
  },

  computed: {
    totalScore () {
      let question = _.map(this.trainingData, 'questions')
      let sum = 0
      for (let index = 0; index < question.length; index++) {
        let element = question[index]
        for (let elementIndex = 0; elementIndex < element.length; elementIndex++) {
          let innerElement = element[elementIndex]
          sum += innerElement.score
        }
      }
      return sum
    }
  },

  mounted () {
    this.getTrainingSetting()
  },

  destroyed () {
    sessionStorage.removeItem('menu')
  },

  methods: {
    getTrainingSetting () {
      var temp = JSON.parse(sessionStorage.getItem('menu'))
      switch (this.displayType) {
        /** 解决接口参数错误问题 */
        case '发动机':
          this.apiIdentity = temp[0].value
          this.stepSecond = temp[0].name
          break
        case '气缸':
          this.apiIdentity = temp[1].value
          this.stepSecond = temp[1].name
          break
        case '曲轴':
          this.apiIdentity = temp[2].value
          this.stepSecond = temp[2].name
          break
        case '变速器同步器':
          this.apiIdentity = temp[3].value
          this.stepSecond = temp[3].name
          break
      }
      if (this.apiIdentity) {
        this.$xhrGet(`/projects/${this.apiIdentity}/items/processes/train`).then(rs => {
          this.trainingData = rs.data
        })
      }
    },
    /** delete question */
    handleDeleteQuestion (ques, row) {
      this.$xhrDelete(`/processes/questions/${ques.questionId}`).then(rs => {
        if (rs.code === 200) {
          this.$message.success('删除试题成功！')
          this.getTrainingSetting()
        }
      })
    },
    /** edit question */
    handleEditQuestion (ques, row) {
      this.quesIdentify = ques
      this.processIdentify = row
      this.$set(this.quesIdentify, 'edit', true)
      this.quesEditorVisible = true
    },
    /** add question */
    handleAddQuestion (row) {
      this.quesIdentify = {}
      this.processIdentify = row
      this.$set(this.quesIdentify, 'edit', false)
      this.quesEditorVisible = true
    },
    handleEditResult () {
      this.getTrainingSetting()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tag--info /deep/ {
  .el-icon-edit {
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: 12px;
    height: 16px;
    width: 16px;
    line-height: 16px;
    vertical-align: middle;
    top: -1px;
    right: -5px;
  }
}
.el-tag--info /deep/ {
  .el-icon-edit:hover {
    background-color: #909399;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/training/TrainingSetting.vue